module.exports = __webpack_public_path__ + "images/create-first-board/card-back/cardBack-zh-hant.d43f08d671326e47d491.svg";